import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '../ui/Button';
export function AboutSection() {
  return <section className="py-24 bg-white overflow-hidden" data-id="element-31" data-mp="2yai2pwqjcoql">
      <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32" data-mp="2tbybphx34mrd">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-33" data-mp="2teasvsv0qt3d">
          {/* Image Grid */}
          <div className="w-full lg:w-1/2 relative" data-id="element-34" data-mp="2of7zx6sbcdbr">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-brand-lighter rounded-full blur-3xl -z-10 opacity-50" data-id="element-35" data-mp="3lzu6ui70a6m1" />

            <div className="grid grid-cols-2 gap-4 relative" data-id="element-36" data-mp="3cb2isl52g6ge">
              <div className="space-y-4 mt-8" data-id="element-37" data-mp="3c99br4qjjk7v">
                <img src="https://cdn.magicpatterns.com/uploads/bSWABHBGqVKzy2mDFo1ntQ/20231218231601_IMG_0654-02.jpg" alt="Maisha doctor consulting with a patient at the clinic" className="rounded-2xl shadow-soft object-cover h-64 w-full" data-id="element-38" data-mp="37ciwgjmk8sni" />
                <div className="bg-brand-navy p-6 rounded-2xl text-white shadow-soft-lg" data-id="element-39" data-mp="1ld8dbq3pcau8">
                  <div className="text-4xl font-heading font-bold text-brand-gold mb-2" data-id="element-40" data-mp="1qd33frfnkwe8">
                    10+
                  </div>
                  <div className="text-sm font-medium text-slate-200" data-id="element-41" data-mp="1bn5ntzvshf0n">
                    Years of Healthcare Excellence
                  </div>
                </div>
              </div>
              <div className="space-y-4" data-id="element-42" data-mp="12m7hvc1sixff">
                <div className="bg-brand-red p-6 rounded-2xl text-white shadow-soft-lg" data-id="element-43" data-mp="12pd66p2lhva3">
                  <h3 className="font-heading font-bold text-xl mb-2" data-id="element-44" data-mp="16mhnuopl1nua">
                    Our Mission
                  </h3>
                  <p className="text-sm text-white/90" data-id="element-45" data-mp="xnntl4zq59jw">
                    To promote health and well-being by delivering professional,
                    compassionate, and evidence-based medical care.
                  </p>
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/jf5yCN4y2vq9FMaMGCpqo3/20231218232322_IMG_0670-01.jpg" alt="Maisha doctor examining a young patient with a stethoscope" className="rounded-2xl shadow-soft object-cover h-72 w-full" data-id="element-46" data-mp="2s1f03vmrbdb4" />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="w-full lg:w-1/2" data-id="element-47" data-mp="2bosk4xo3ffa0">
            <span className="text-brand-red font-semibold tracking-wider text-sm uppercase mb-3 block" data-id="element-48" data-mp="39b9h21swzqv8">
              Our Story
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-brand-navy mb-6 leading-tight" data-id="element-49" data-mp="34dhemdun8mcs">
              Dedicated to the Health of Our Community
            </h2>

            <p className="text-slate-600 text-lg mb-6 leading-relaxed" data-id="element-50" data-mp="2ulbqjf7iip2v">
              Nora-Pack Technics (Pty) Ltd was registered in Botswana in 2013 and has been providing healthcare services to the Tsabong community for over a decade. In 2020, the healthcare facility adopted the name Maisha Medical Center, marking a new chapter in its continued commitment to serving the community.
            </p>
            <p className="text-slate-600 text-lg mb-8 leading-relaxed" data-id="element-51" data-mp="3gxb02811rpj">
              For over a decade, we have remained committed to delivering accessible, quality medical services that prioritise patient care, innovation and community well-being. Today, Maisha Medical Center continues to provide comprehensive healthcare services designed to meet the needs of individuals and families in Tsabong and surrounding communities.


            </p>

            <ul className="space-y-4 mb-10" data-id="element-52" data-mp="mcdl1wbcu6v3">
              {['Patient-centered approach to every treatment', 'State-of-the-art diagnostic and laboratory equipment', 'Experienced and compassionate medical staff', 'Comprehensive care for the whole family'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-53" data-mp="163iikfr2s3t2" data-mpi={idx}>
                  <CheckCircle2 className="w-6 h-6 text-brand-gold shrink-0 mt-0.5" data-id="element-54" data-mp="22tkn9r6cqenn" />
                  <span className="text-slate-700 font-medium" data-id="element-55" data-mp="1xvashhojhg2k">{item}</span>
                </li>)}
            </ul>

            <div className="flex flex-wrap gap-4" data-id="element-56" data-mp="2civuf89oh98w">
              <Button href="/about" variant="primary" data-id="element-57" data-mp="2clqf90wlsw2u">
                Read Our Full Story
              </Button>
              <Button href="/doctors" variant="outline" data-id="element-58" data-mp="1jv020fr563hx">
                Meet Our Doctors
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}